import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { GET_NOTIFICATION, GET_SETTINGS, SETTINGS_UPDATE } from "./actionType"
import { settingsUpdateError, settingsUpdateSuccess, settingsUpdateLoading, getSettingsLoading, getSettingsError, getSettingsSuccess, getNotificationError, getNotificationLoading, getNotificationSuccess } from "./action"
//Include Both Helper File with needed methods
import { postSettingsUpdate, getSettings, getNotificationUrl } from "../../helpers/backend_helper"
import "toastr/build/toastr.min.css"
import toast from "react-hot-toast";

//update settings
function* settingsUpdate({ payload: { data, dispatch, getSettings, setDisabled } }) {
  try {
    yield put(settingsUpdateLoading(true))
    const response = yield call(postSettingsUpdate, data)
    yield put(settingsUpdateLoading(false))
    if (response.status === 'error') {
      toast.error(response.message)
    } else {
      yield put(settingsUpdateSuccess(response))
      toast.success(response.message)
      setDisabled(true)
      dispatch(getSettings())
    }
  } catch (error) {
    yield put(settingsUpdateError(error))
  }
}

function* SettingsUpdateSaga() {
  yield takeEvery(SETTINGS_UPDATE, settingsUpdate)
}

export default SettingsUpdateSaga

//get settings
function* fetchSettings() {
  try {
    yield put(getSettingsLoading(true))
    const response = yield call(getSettings)
    yield put(getSettingsSuccess(response))
    getSettingsLoading(false)
  } catch (error) {
    yield put(getSettingsError(error))
  }
}
export function* GetSettingsSaga() {
  yield takeEvery(GET_SETTINGS, fetchSettings)
}


//get settings
function* fetchNotification() { 
  try {
    yield put(getNotificationLoading(true))
    const response = yield call(getNotificationUrl) 
    yield put(getNotificationSuccess(response))
    getNotificationLoading(false)
  } catch (error) { 
    yield put(getNotificationError(error))
  }
}
export function* GetNotificationSaga() {
  yield takeEvery(GET_NOTIFICATION, fetchNotification)
}